import React from 'react';

import { APPENDIX_ENTRY_HEIGHT, APPENDIX_LETTER_WIDTH, box, CONTENT_WIDTH, MARGIN_X, pt } from '../slideGeometry';

/**
 * The appendix index: one row per appendix, its letter then its title and
 * the slides it runs to, each as tall as the Paginator fitted it
 * (`fit.height`), the label wrapping within it.
 */
const AppendixIndexBlock = ({ block }) => {
    let top = block.y;

    return (block.entries || []).map((entry) => {
        const label = entry.label || `${entry.letter} ${entry.title}`;
        const text = label.startsWith(`${entry.letter} `) ? label.slice(entry.letter.length + 1) : label;
        const height = entry.fit?.height ?? APPENDIX_ENTRY_HEIGHT;
        const y = top;
        top += height;

        return (
            <div key={entry.letter} className="tw-flex tw-items-center tw-border-b tw-border-charcoal-15" style={box(MARGIN_X, y, CONTENT_WIDTH, height)}>
                <span className="tw-text-blue tw-font-bold tw-shrink-0" style={{ width: APPENDIX_LETTER_WIDTH, fontSize: pt(9) }}>
                    {entry.letter}
                </span>
                <span className="tw-text-charcoal tw-flex-1" style={{ fontSize: pt(11) }}>
                    {text}
                </span>
            </div>
        );
    });
};

export default AppendixIndexBlock;
